export default "__VITE_ASSET__CnY$beF3__"